module.exports = __webpack_public_path__ + "img/pickThree_g.6e842141.png";